import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_LOT_BALANCE } from '../types/stock-lot-balance.js';
/**
 * Descriptor for StockLotBalance — per-lot sub-ledger (request 0107).
 * Mutated only by the ledger store.
 */
export const stockLotBalanceDescriptor = {
    name: STOCK_LOT_BALANCE,
    label: 'Saldo por Lote',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-lot-balance',
    pathPatternKeys: { orgId: 'string' },
    version: 2,
    description: 'Per-lot quantity at a stock location (no reservation)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: true },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        {
            name: 'ownerPartyId',
            label: 'Proprietário',
            type: 'string',
            required: false,
            description: 'FK → Party; null = estoque próprio (0044)',
        },
        { name: 'quantity', label: 'Saldo', type: 'number', display: 'quantity', required: true },
        {
            name: 'lastMovementAt',
            label: 'Última movimentação',
            type: 'date',
            display: 'datetime',
            required: false,
        },
        { name: 'updatedAt', label: 'Atualizado em', type: 'date', display: 'datetime', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'ownerPartyId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
        },
    ],
};
//# sourceMappingURL=stock-lot-balance.descriptor.js.map